import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import ViewerBanner from "@/components/ViewerBanner";
import { useIsViewer } from "@/lib/permissions";
import { toast } from "sonner";
import { Heart, Trash, Star } from "@phosphor-icons/react";

export default function Favourites() {
  const viewer = useIsViewer();
  const [items, setItems] = useState([]);
  const load = () => api.get("/company/favourites").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const remove = async (staff_id) => {
    try { await api.delete(`/company/favourites/${staff_id}`); load(); }
    catch { toast.error("Failed"); }
  };
  return (
    <div className="space-y-4">
      {viewer && <ViewerBanner />}
      <div className="flex items-center gap-3">
        <Heart size={28} className="text-red-500" weight="fill" />
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Favourite staff</h1>
      </div>
      <p className="text-slate-600">Tagged workers appear first when matching new jobs (+5 match score).</p>
      {items.length === 0 && <div className="card-tactile p-8 text-center text-slate-500">No favourites yet. Tag staff from a job's matches list.</div>}
      <div className="grid md:grid-cols-2 gap-3">
        {items.map((f) => (
          <div key={f.staff_id} className="card-tactile p-5 flex items-start justify-between gap-3" data-testid={`fav-${f.staff_id}`}>
            <div>
              <div className="font-display text-lg font-bold text-slate-900">{f.staff?.first_name} {f.staff?.last_name}</div>
              <div className="text-sm text-slate-600">{f.staff?.email}</div>
              <div className="mt-1 flex items-center gap-2 text-sm">
                {f.staff?.rating > 0 && <span className="flex items-center gap-1"><Star size={12} weight="fill" className="text-yellow-500"/> {f.staff.rating.toFixed(1)}</span>}
                <span className="text-slate-500">{f.staff?.city}</span>
              </div>
              {f.note && <div className="text-xs text-slate-500 mt-1 italic">"{f.note}"</div>}
              <div className="mt-2 flex flex-wrap gap-1">
                {(f.staff?.skills || []).slice(0,3).map(s => <span key={s} className="px-2 py-0.5 rounded-md bg-slate-100 text-xs font-semibold">{s}</span>)}
              </div>
            </div>
            {!viewer && <Button variant="outline" size="sm" onClick={()=>remove(f.staff_id)} data-testid={`fav-remove-${f.staff_id}`} className="text-red-600 border-red-200 hover:bg-red-50"><Trash size={14}/></Button>}
          </div>
        ))}
      </div>
    </div>
  );
}
